import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateSetting } from '@services/settings';
import { SettingUpdateInput } from '@models/setting.model';
import { toast } from 'react-toastify';
import { SETTINGS_QUERY_KEY } from './useSettings';
import { useTranslation } from '@hooks/useTranslation';

interface UpdateSettingParams {
  settingId: string;
  input: SettingUpdateInput;
}

export const useUpdateSetting = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ settingId, input }: UpdateSettingParams) =>
      updateSetting(settingId, input),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: SETTINGS_QUERY_KEY });
      queryClient.invalidateQueries({
        queryKey: [...SETTINGS_QUERY_KEY, variables.settingId],
      });
      toast.success(tActionMessages.settingUpdatedSuccessfully);
    },
    onError: (error: any) => {
      const message = error?.response?.errors?.[0]?.message || tActionMessages.requestError;
      toast.error(message);
    },
  });
};

export default useUpdateSetting;
